import React from 'react';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import App from '../components/App';
import DashboardLayout from '../layouts/DashboardLayout';

const AppRouter = () => {
  return (
    <Router>
      <Switch>
        <Redirect exact from="/" to="/super-admin/" />
        <Redirect exact from="/login" to="/super-admin/login" />
        <Route exact path="/super-admin/login" component={App} />
        <Route path="/super-admin" component={DashboardLayout} />
        <Route exact path="/admin" component={DashboardLayout} />
        <Route component={App} />
      </Switch>
    </Router>
  );
};

export default AppRouter;
